'use client'

import { useCountdown } from '@/hooks/use-countdown'
import { cn } from '@/lib/utils'
import { formatUpcomingDate } from '@utils/common'
import { ClockIcon, DetailText } from 'design-configuration/components'
import React from 'react'

export const UpcomingReleaseDate = ({
  startTime,
  dark,
  releasingText = true
}: {
  startTime: string
  dark?: boolean
  releasingText?: boolean
}): React.ReactElement => {
  const start = new Date(`${startTime}`)
  const ONE_DAY = 24 * 60 * 60 * 1000
  const now = new Date()
  const lessThan24hr = start.getTime() - now.getTime() < ONE_DAY
  const countdown = useCountdown(start)

  let upcomingDateString = ''
  if (lessThan24hr) {
    const hours = countdown?.hours ?? 0
    const minutes = countdown?.minutes ?? 0
    const seconds = countdown?.seconds ?? 0
    upcomingDateString = `Starting in ${hours > 0 ? `${hours} hr ` : ''}${minutes} min${hours === 0 ? ` ${seconds} sec` : ''}`
  } else {
    upcomingDateString = `${releasingText ? 'RELEASING ON ' : ''}${formatUpcomingDate(start)}`
  }
  return (
    <div
      className={cn(
        'gap-x-2xs px-2xs flex w-fit flex-row items-center',
        dark
          ? 'bg-surface-container-inverted text-on-surface-inverted fill-on-surface-inverted'
          : 'bg-surface-container text-on-surface fill-on-surface'
      )}
    >
      <ClockIcon />
      <DetailText className="font-medium uppercase">{upcomingDateString}</DetailText>
    </div>
  )
}
